import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["envKey", "debug", "beaconCollectionDomain", "playbackId", "preferPlayback", "type", "streamType", "startTime", "src", "children", "autoPlay", "preload"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect as V, useRef as v } from "react";

var d = function d() {
  for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
    r[_key] = arguments[_key];
  }

  var o = v(null);
  return V(function () {
    r.forEach(function (n) {
      !n || (typeof n == "function" ? n(o.current) : n.current = o.current);
    });
  }, [r]), o;
};

import m, { useEffect as i, useRef as T, useState as R } from "react";
import e from "prop-types";
import { allMediaTypes as L, initialize as j, StreamTypes as w, PlaybackTypes as H, toMuxVideoURL as M, generatePlayerInitTime as I } from "@mux/playback-core";

var k = function k() {
  try {
    return "0.7.1";
  } catch (_unused) {}

  return "UNKNOWN";
},
    S = k(),
    b = function b() {
  return S;
};

var N = b(),
    h = "mux-video-react",
    P = m.forwardRef(function (r, o) {
  var y;

  var n = r.envKey,
      A = r.debug,
      D = r.beaconCollectionDomain,
      s = r.playbackId,
      K = r.preferPlayback,
      U = r.type,
      W = r.streamType,
      _ = r.startTime,
      c = r.src,
      x = r.children,
      l = r.autoPlay,
      f = r.preload,
      g = _objectWithoutProperties(r, _excluded),
      _R = R(I()),
      _R2 = _slicedToArray(_R, 1),
      C = _R2[0],
      _R3 = R((y = M(s)) != null ? y : c),
      _R4 = _slicedToArray(_R3, 2),
      u = _R4[0],
      E = _R4[1],
      a = T(void 0),
      O = T(null),
      p = d(O, o);

  return i(function () {
    var t;
    E((t = M(s)) != null ? t : c);
  }, [c, s]), i(function () {
    var t = _objectSpread(_objectSpread({}, r), {}, {
      src: u,
      playerInitTime: C,
      playerSoftwareName: h,
      playerSoftwareVersion: N,
      autoplay: l
    });

    p.current && (a.current = j(t, p.current, a.current));
  }, [u]), i(function () {
    var t;
    (t = a.current) == null || t.setAutoplay(l);
  }, [l]), i(function () {
    var t;
    (t = a.current) == null || t.setPreload(f);
  }, [f]), m.createElement("video", _objectSpread({
    ref: p
  }, g), x);
});
P.propTypes = {
  envKey: e.string,
  debug: e.bool,
  disableCookies: e.bool,
  metadata: e.any,
  beaconCollectionDomain: e.string,
  playbackId: e.string,
  playerInitTime: e.number,
  preferPlayback: e.oneOf(Object.values(H)),
  type: e.oneOf(L),
  streamType: e.oneOf(Object.values(w)),
  startTime: e.number
};
var $ = P;
export { $ as default };